import axios from "./axios";

const qs = require('qs')

const action = {
    async AccountInfo(TaxNumber) {
        return await axios().get(
            "/Account/Info", {params: {TaxNumber: TaxNumber}}
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async AccountCreate(model) {
        return await axios().post(
            "/UserAccount/Process/Create", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async CheckEmail(Email) {
        return await axios().get(
            `/Account/CheckEmail/${Email}`,
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async CheckDealerCode(DealerCode) {
        return await axios().get(
            `/Dealers/${DealerCode}`,
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async GetModules() {
        return await axios().get(
            "/Modules"
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async GetNonModules(CompanyID) {
        return await axios().get(
            "/Modules/NonModule", {params: {CompanyID: CompanyID}}
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async GetActiveModules(CompanyID) {
        return await axios().get(
            "/Modules/CompanyModule", {params: {CompanyID: CompanyID}}
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async EInvoice(model) {
        return await axios().post(
            "/Preview/EInvoice", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async EArchive(model) {
        return await axios().post(
            "/Preview/EArchive", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async EDespatch(model) {
        return await axios().post(
            "/Preview/EDespatch", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async EDespatchAnswer(model) {
        return await axios().post(
            "/Preview/EDespatchAnswer", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async ESMM(model) {
        return await axios().post(
            "/Preview/ESMM", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async EMM(model) {
        return await axios().post(
            "/Preview/EMM", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async EBill(model) {
        return await axios().post(
            "/Preview/EBill", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async EInsurance(model) {
        return await axios().post(
            "/Preview/EInsurance", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async Expense(model) {
        return await axios().post(
            "/Preview/Expense", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async ProcessUserAccount(model) {
        return await axios().get(
            "/UserAccount/Process",
            {
                params: {
                    "Page": model.Page,
                    "PageSize": model.PageSize,
                    "TaxNumber": model.TaxNumber
                },
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async CancelUserAccount(model) {
        return await axios().get(
            "/UserAccount/Cancel",
            {
                params: {
                    "Page": model.Page,
                    "PageSize": model.PageSize,
                    "TaxNumber": model.TaxNumber
                },
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async ProcessEnvelopeBase64(model) {
        return await axios().get(
            `/UserAccount/Process/${model.TaxNumber}/${model.EnvelopeUUID}`
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async CancelEnvelopeBase64(model) {
        return await axios().get(
            `/UserAccount/Cancel/${model.TaxNumber}/${model.EnvelopeUUID}`
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async ProcessConfirm(model) {
        return await axios().post("/UserAccount/Process/Confirm", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async CancelConfirm(model) {
        return await axios().post("/UserAccount/Cancel/Confirm", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    }
}

export default action
